// extracted by mini-css-extract-plugin
module.exports = {"clickableToken":"StandaloneToken_clickableToken__3koIM"};